import ContactPersons from 'components/Person/ContactPersons';

export default ContactPersons;
